export default __webpack_public_path__ + "static/media/accessibility.6eb6405f.png";